<template>
  <svg :width="width" :height="height" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.6667 1.66797C17.1267 1.66797 17.5 2.0413 17.5 2.5013V5.63214L15.8333 7.2988V3.33464H4.16667V16.668H15.8333V14.3696L17.5 12.703V17.5013C17.5 17.9613 17.1267 18.3346 16.6667 18.3346H3.33333C2.87333 18.3346 2.5 17.9613 2.5 17.5013V2.5013C2.5 2.0413 2.87333 1.66797 3.33333 1.66797H16.6667ZM18.1483 7.3413L19.3267 8.51964L12.845 15.0013L11.665 14.9996L11.6667 13.823L18.1483 7.3413ZM10.8333 10.0013V11.668H6.66667V10.0013H10.8333ZM13.3333 6.66797V8.33464H6.66667V6.66797H13.3333Z" :fill="color" fill-opacity="1"/>
  </svg>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
@Component({
  name: 'WcIconDescription',
  components: {},
  props: {
    color: {
      type: String,
      default: '#ffffff'
    }
  }
})
export default class extends Vue {
  @Prop({ default: '#ffffff' }) color!: String;
  @Prop({ default: '20' }) height!: String;
  @Prop({ default: '20' }) width!: String;
}
</script>

<style scoped>
</style>
